import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import type { IncomeSource } from 'src/pages/loan/income/data';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import {
  toIncomeSource,
  toLoanIncomePayload,
  type LoanIncomeDto,
} from './mapLoanIncome';

export interface CreateLoanIncomeParams {
  loanId: string;
  row: IncomeSource;
}

const createLoanIncome: MutationFunction<
  IncomeSource,
  CreateLoanIncomeParams
> = async ({ loanId, row }) => {
  if (isMockServices()) return await mock({ ...row, id: `i-${Date.now()}` });

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: LoanIncomeDto;
  }>(`/loans/${loanId}/incomes`, {
    method: 'POST',
    body: {
      incomeType: row.type,
      borrowerPairId: row.borrowerPairId ?? null,
      scope: row.scope ?? null,
      income: toLoanIncomePayload(row),
    },
  });

  if (response.data) return toIncomeSource(response.data.data);
  throw new Error('Failed to create income');
};

export default createLoanIncome;
